import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

/**
 * Default Angular serializer encodes `|` as `%7C` in query strings.
 * For readable URLs (e.g. category_ids=4|7), we show the pipe in the address bar.
 * Only the query segment is rewritten; paths are unchanged.
 */
@Injectable()
export class PipeFriendlyUrlSerializer implements UrlSerializer {
  private readonly defaultSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    return this.defaultSerializer.parse(url);
  }

  serialize(tree: UrlTree): string {
    const encoded = this.defaultSerializer.serialize(tree);
    const q = encoded.indexOf('?');
    if (q === -1) {
      return encoded;
    }
    const base = encoded.slice(0, q + 1);
    const query = encoded.slice(q + 1).replace(/%7C/gi, '|');
    return base + query;
  }
}
